import { render } from "./CustomHtmlElement.vue.js?vue&type=template&id=39253e9b!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomHtmlElement.vue?vue&type=template&id=39253e9b"
import script from "./CustomHtmlElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomHtmlElement.vue?vue&type=script&lang=js"
export * from "./CustomHtmlElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomHtmlElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/custom-html-element/CustomHtmlElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39253e9b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39253e9b', __exports__)) {
    api.reload('39253e9b', __exports__)
  }
  
  module.hot.accept("./CustomHtmlElement.vue.js?vue&type=template&id=39253e9b!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomHtmlElement.vue?vue&type=template&id=39253e9b", () => {
    api.rerender('39253e9b', render)
  })

}


export default __exports__